import axios from "axios";
import { getToken, ShowErrorAlert } from "../views/Common/GlobalSession";

export const getUpdateGrowthPlanApi = async (obj) => {
  //console.log("inside getCategoryApi api call");
  try {
    // Get the authentication token
    let tokenStr = getToken();

    // headers: {"Authorization" : `Bearer ${tokenStr}`}
    const response = await axios({
      method: "POST",
      url: process.env.REACT_APP_API_END_POINT + "/updateGrowthplanSummary",
      data: obj.inputParams,
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((Response) => Response)
      .then((res) => {
        // console.log("inside getCategoryAPI");
        //  console.log(res.data);
        return res.data;
      });
    return response;
  } catch (e) {
    console.log(e);
    if (e.response && e.response.status === 401) {
      ShowErrorAlert(4, e.response.data.error.message);
    }
  }
};
